<template>
  <div class="property-page">
    <!-- 히어로 섹션 (건물 이미지 + 텍스트 오버레이) -->
    <section class="hero-section">
      <div class="building-image">
        <img src="@/assets/전면사진.jpg" alt="건물 외관" />
        <div class="text-overlay">
          <h3>{{ locationText }}</h3>
          <h2 v-html="propertyName"></h2>
          <p v-html="propertyDescription"></p>
        </div>
      </div>
    </section>

    <!-- 정보 테이블 섹션 -->
    <section class="info-table-section">
      <table class="info-table">
        <thead>
          <tr>
            <th class="table-header">주택위치</th>
            <td class="table-content">{{ location }}</td>
            <th class="table-header">건축규모</th>
            <td class="table-content">{{ buildingSize }}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th class="table-header">대지면적</th>
            <td class="table-content">{{ landArea }}</td>
            <th class="table-header">연면적</th>
            <td class="table-content">{{ totalArea }}</td>
          </tr>
          <tr>
            <th class="table-header">공급세대</th>
            <td class="table-content">{{ units }}</td>
            <th class="table-header">주차대수</th>
            <td class="table-content">{{ parkingSpaces }}</td>
          </tr>
        </tbody>
      </table>
    </section>

  </div>
</template>

<script>
export default {
  name: 'PropertySimple',
  data() {
    return {
      locationText: '2호선 서울대입구역 역세권 청년주택',
      propertyName: 'BX201 서울대청년안심주택',
      propertyDescription: '신혼부부&청년 2030세대의<br> 라이프스타일을 지켜줄최적의 맞춤형<br> 청년주택',
      
      location: '서울시 관악구 남부순환로 224길 25 (2호선 서울대입구역 1,2번 출구)',
      buildingSize: '자하 2층, 지상 20층, 1개 동',
      landArea: '815.2㎡',
      totalArea: '8,239.52㎡',
      units: '총 201세대 중 민간임대 170세대(특별공급 34세대, 일반공급 136세대)',
      parkingSpaces: '77대(기계식주차장)'
    }
  }
}
</script>

<style scoped>
/* 기본 스타일 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Noto Sans KR', sans-serif;
  line-height: 1.6;
  color: #333;
}
.property-page {
  position: relative;
  max-width: 1200px; /* ✅ 최대 너비 1500px */
  margin: 0 auto;
}

/* 히어로 섹션 스타일 */
.hero-section {
  position: relative;
  width: 100%;
  max-width: 1500px; /* ✅ 최대 너비 1500px */
  height: 60vh; /* ✅ 높이 조금 더 크게 조정 */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* 이미지와 텍스트를 flex로 정렬 */
.building-image {
  display: flex;
  width: 100%;
  max-width: 1500px; /* ✅ 최대 너비 1500px */
  height: 60vh; /* ✅ 높이도 히어로 섹션과 맞춤 */
  position: relative;
  overflow: hidden;
}

.building-image img {
  width: 70%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.text-overlay {
  position: absolute;
  right: 0;
  width: 30%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.text-overlay h3 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-overlay h1 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 10px;
  line-height: 1.2;
}

.text-overlay p {
  font-size: 16px;
  line-height: 1.6;
}

/* 정보 테이블 스타일 */
.info-table-section {
  max-width: 1500px;
  padding-top: 50px;
  margin: 0 auto;
  padding-bottom: 80px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  border-top: 2px solid #ddd;
  border-bottom: 2px solid #ddd;
  background-color: #fff;
}

.info-table thead {
  background-color: #f4f4f9;
}

.info-table th {
  background-color: #f4f4f9;
  font-weight: 600;
  text-align: center; /* 제목은 가운데 정렬 */
  padding: 15px;
}

.info-table td {
  padding: 15px;
  text-align: left; /* 내용은 왼쪽 정렬 */
  border-bottom: 1px solid #ddd;
}

/* 좌우 테두리 제거 */
.info-table th:first-child,
.info-table td:first-child,
.info-table th:last-child,
.info-table td:last-child {
  border-left: none;
  border-right: none;
}

/* 짝수 행 배경색 변경 */
.info-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .hero-section {
    flex-direction: column;
    height: auto;
  }
  
.building-image {
  flex-direction: column;
  width: 100%;
  height: auto; /* ✅ 높이를 50%로 줄임 (필요시 조정) */
  overflow: hidden;
}

.building-image img {
    width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
}
  .text-overlay {
    text-align: center;
    position: relative;    /* absolute → relative */
    width: 100%;
    height: auto;
    background: rgba(0,0,0,0.7);
    padding: 24px;
    box-sizing: border-box;
  }

  .info-table-section {
    max-width: 600px; /* ✅ 모바일에서 테이블 너비 고정 */
    margin: 0 auto;
    overflow-x: auto; /* ✅ 테이블이 넘칠 경우 스크롤 */
  }

  .info-table {
    width: 100%;
    font-size: 0.85rem; /* ✅ 모바일 폰트 크기 줄임 */
    border-collapse: collapse;
  }

  .info-table thead {
    background-color: #f4f4f9;
  }

  .info-table th {
    font-size: 0.9rem; /* ✅ 모바일 제목 폰트 크기 줄임 */
    font-weight: 600;
    text-align: center;
    padding: 10px;
  }

  .info-table td {
    padding: 8px;
    font-size: 0.8rem; /* ✅ 모바일 내용 폰트 크기 줄임 */
    text-align: left;
  }

  .info-table tr {
    border-bottom: 1px solid #ddd;
  }

  .table-header {
    background-color: #f4f4f9;
    padding: 10px;
    font-size: 0.9rem; /* ✅ 모바일 제목 폰트 크기 */
    font-weight: 600;
    text-align: center;
  }

  .table-content {
    font-size: 0.8rem; /* ✅ 모바일에서 더 작은 폰트 */
    padding: 8px;
    text-align: left;
  }
}


</style>
